import * as Yup from "yup";

export const giftOrderValidation = Yup.object().shape({
  gtePrice: Yup.number()
    .required("وارد کردن حداقل مبلغ فاکتور الزامی است"), 
  name: Yup.string()
    .required("وارد کردن نام الزامی است")
});
